window.dtReservationHour = function () {}
